(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function(event) {
     if (typeof T4STheme !== 'undefined' && T4STheme.Flickity) {
        T4STheme.Flickity.sections(event.target);
     }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-instagram"] && !Shopify.designMode) return;
  try {
    
  const initEngine = (sid) => {
    const data = JSON.parse(document.getElementById('insta-data-'+sid).innerHTML);
    const dr = document.getElementById('t4s-insta-drawer-'+sid);
    const list = dr.querySelector('#dm-final-list');
    const scroller = dr.querySelector('#dm-scroller');
    const hT = dr.querySelector('#dm-title'), hC = dr.querySelector('#dm-count');

    const open = (hid) => {
       const g = data.groups[hid];
       hT.textContent = g.title; hC.textContent = g.posts.length + " posts";
       renderRows(g);
       
       // RESET SCROLL to START
       scroller.scrollTop = 0;
       
       dr.classList.add('is--open'); document.body.style.overflow='hidden';
    };

    const renderRows = (g) => {
       list.innerHTML = '';
       g.posts.forEach(p => {
          const row = document.createElement('div');
          row.className = 't4s-insta-post-row';
          row.style.borderBottom = `1px ${g.bs} ${g.bc}`;
          const cleanT = p.p.t.split('|')[0].trim();

          row.innerHTML = `
            <div class="t4s-row-usr">
               <div class="t4s-usr-meta">
                  <img data-wpsob="1" data-wpsob-height="1" height="1" data-wpsob-width="1" width="1" data-wpsob-lazy="1" loading="lazy" src="${p.pfp}" class="t4s-usr-pfp" alt="">
                  <div class="t4s-usr-un">${p.un}</div>
               </div>
               <div class="t4s-usr-cap">${p.cap}</div>
               <a href="${p.soc}" target="_blank" class="t4s-usr-soc-lnk">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                  VIEW ON SOCIAL
               </a>
            </div>
            <div class="t4s-row-med">
               <img data-wpsob="1" data-wpsob-height="1" height="1" data-wpsob-width="1" width="1" data-wpsob-lazy="1" loading="lazy" src="${p.img}" class="t4s-med-img" alt="">
               <div class="t4s-med-plus">
                  <svg class="plus-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  <svg class="minus-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2.5" style="display:none;"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
               </div>
            </div>
            <div class="t4s-row-prd">
               <div class="t4s-mini-card">
                  <div class="t4s-mini-img-wrap">
                     <img data-wpsob="1" data-wpsob-height="1" height="1" data-wpsob-width="1" width="1" data-wpsob-lazy="1" loading="lazy" src="${p.p.img}" class="t4s-mini-img" alt="">
                     <div class="t4s-mini-info">
                        <div class="t4s-mini-ttl">${cleanT}</div>
                        <div class="t4s-mini-prc">${p.p.pr}</div>
                     </div>
                  </div>
                  <div class="t4s-mini-cart"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>
               </div>
               <div class="t4s-prd-full">
                  <div class="t4s-prd-back"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5"><polyline points="15 18 9 12 15 6"/></svg> BACK</div>
                  <div class="t4s-prd-f-header">
                     <img data-wpsob="1" data-wpsob-height="1" height="1" data-wpsob-width="1" width="1" data-wpsob-lazy="1" loading="lazy" src="${p.p.img}" class="t4s-prd-f-img" alt="">
                     <div class="t4s-prd-f-info">
                        <h3 class="t4s-prd-f-ttl">${cleanT}</h3>
                        <span class="t4s-prd-f-prc">${p.p.pr}</span>
                     </div>
                  </div>
                  <div class="t4s-row-sw"></div>
                  <button class="t4s-prd-atc">ADD TO CART</button>
                  <a href="${p.url}" class="t4s-prd-full-link">SHOP FULL PRODUCT</a>
               </div>
            </div>
          `;
          initRow(row, p);
          list.appendChild(row);
       });
    };

    const initRow = (row, p) => {
       const mini = row.querySelector('.t4s-mini-card'), full = row.querySelector('.t4s-prd-full'), plusB = row.querySelector('.t4s-med-plus'), back = row.querySelector('.t4s-prd-back');
       const pI = plusB.querySelector('.plus-icon'), mI = plusB.querySelector('.minus-icon'), swAt = row.querySelector('.t4s-row-sw'), atc = row.querySelector('.t4s-prd-atc');
       
       const toggle = (st) => {
          if(st === 'full') {
             mini.classList.add('is--hide'); full.classList.add('is--active');
             pI.style.display='none'; mI.style.display='block';
          } else {
             mini.classList.remove('is--hide'); full.classList.remove('is--active');
             pI.style.display='block'; mI.style.display='none';
          }
       };

       mini.onclick = () => toggle('full');
       plusB.onclick = () => (full.classList.contains('is--active') ? toggle('mini') : toggle('full'));
       back.onclick = () => toggle('mini');

       let sel = {}; let curV = null;
       p.p.os.forEach(o => {
          swAt.appendChild(Object.assign(document.createElement('div'),{className:'t4s-sw-v-ttl',textContent:o.n}));
          const rowS = document.createElement('div'); rowS.className='t4s-sw-v-row';
          o.vs.forEach(v => {
             const i = document.createElement('div');
             if(o.n.toLowerCase().includes('color')) {
                i.className='t4s-sw-v-cir'; i.innerHTML=`<span style="background-color:${v.toLowerCase().replace(' ','')}"></span>`;
             } else { i.className='t4s-sw-v-pill'; i.textContent=v; }
             if(v===o.vs[0]){i.classList.add('is--active'); sel[o.n]=v;}
             i.onclick=()=>{ rowS.querySelectorAll('div').forEach(d=>d.classList.remove('is--active')); i.classList.add('is--active'); sel[o.n]=v; update(); };
             rowS.appendChild(i);
          });
          swAt.appendChild(rowS);
       });
       const update = () => {
          const v = p.p.vs.find(va => p.p.os.every((o,i)=>va.ops[i]===sel[o.n]));
          if(v){ curV=v.id; atc.disabled=!v.av; atc.textContent=v.av?"ADD TO CART":"SOLD OUT"; }
       };
       update();
       atc.onclick=()=>{
          if(!curV)return; atc.classList.add('is--loading');
          fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:curV,quantity:1}]})}).then(r=>r.json()).then(d=>{
             atc.classList.remove('is--loading');
             if(window.T4STheme && window.T4STheme.CartDrawer) window.T4STheme.CartDrawer.open(); else window.location.href='/cart';
          });
       };
    };

    document.querySelectorAll('.t4s-js-open-drawer').forEach(b => b.onclick = () => open(b.dataset.hid));
    dr.querySelector('.t4s-dra-close').onclick = () => { dr.classList.remove('is--open'); document.body.style.overflow=''; };
    dr.querySelector('.t4s-insta-drawer-overlay').onclick = () => { dr.classList.remove('is--open'); document.body.style.overflow=''; };

    // Mobile Slider arrows logic
    const container = document.querySelector(`.t4s-section-${sid} .t4s-insta-slider-container`);
    if (container && container.classList.contains('has-slider')) {
       const wrap = container.querySelector('.t4s-insta-circles-wrap');
       const prevBtn = container.querySelector('.t4s-insta-slider-btn.prev');
       const nextBtn = container.querySelector('.t4s-insta-slider-btn.next');
       
       if (wrap && prevBtn && nextBtn) {
          prevBtn.onclick = (e) => {
             e.preventDefault();
             const item = wrap.querySelector('.t4s-insta-circle-item');
             if (item) {
                const itemWidth = item.offsetWidth;
                const gap = 16;
                wrap.scrollBy({ left: -(itemWidth + gap), behavior: 'smooth' });
             }
          };
          nextBtn.onclick = (e) => {
             e.preventDefault();
             const item = wrap.querySelector('.t4s-insta-circle-item');
             if (item) {
                const itemWidth = item.offsetWidth;
                const gap = 16;
                wrap.scrollBy({ left: (itemWidth + gap), behavior: 'smooth' });
             }
          };
       }
    }
  };
  document.addEventListener('DOMContentLoaded', ()=>document.querySelectorAll('.t4s-insta-drawer').forEach(o=>initEngine(o.id.replace('t4s-insta-drawer-',''))));
  document.addEventListener('shopify:section:load', (e)=>{const o=e.target.querySelector('.t4s-insta-drawer');if(o)initEngine(o.id.replace('t4s-insta-drawer-',''));});

  } catch(e) { console.error(e); }
})();
})();
